// Refactored styles for a black banner
export const styles = `
    .root {
        background-color: #111;
        color: #fff;
        z-index: 1000;
        padding-left: 1em;
        padding-right: 1em;
        display: flex;
        align-items: center;
        min-height: 6em;
    }

    .container {
        width: 100%;
        max-width: 1200px;
        margin: 0 auto;
        display: flex;
        gap: 1em;
        align-items: center;
    }
    
    .message {
        flex-grow: 1;
    }

    .countdown {
        font-weight: bold;
    }

    @media (max-width: 768px) {
        .root {
            padding: 0.5em;
            min-height: auto;
        }

        .container {
            flex-direction: column;
            align-items: flex-start;
        }
        
        .message {
            margin-bottom: 0.5em;
        }

        .cta {
            width: 100%;
        }

        .cta a {
            width: 100%;
            text-align: center;
        }
    }
`;

export const decorators = {
    countdown(){
        if(this.node.expiryDate == undefined){
            const initialExpirySeconds = parseInt(this.params.expirySeconds);
            this.node.expiryDate = new Date(Date.now() + initialExpirySeconds * 1000);
        }

        const updateCountdown = () => {
            const expirySeconds = Math.max(0, Math.floor((this.node.expiryDate - Date.now()) / 1000));

            const days = Math.floor(expirySeconds / (24 * 3600));
            const hours = Math.floor((expirySeconds % (24 * 3600)) / 3600);
            const minutes = Math.floor((expirySeconds % 3600) / 60);
            const seconds = expirySeconds % 60;

            let formatted = '';
            if (days > 0) formatted += `${days} ${days == 1 ? 'day' : 'days'}, `;
            if (hours > 0 || days > 0) formatted += `${hours} ${hours == 1 ? 'hour' : 'hours'}, `;
            if (minutes > 0 || hours > 0 || days > 0) formatted += `${minutes} ${minutes == 1 ? 'minute' : 'minutes'} and `;
            formatted += `${seconds} ${seconds == 1 ? 'second' : 'seconds'}`;

            this.patch(formatted.trim());
        };

        updateCountdown();

        this.setInterval(updateCountdown, 1000);
    }
};

export default {
    async render(){
        const { expirySeconds } = this.params;

        return this.renderHtml`
            <div class="${this.cssClasses.root}">
                <div class="${this.cssClasses.container}">
                    <div class="${this.cssClasses.message}">This demo will be automatically deleted in <span class="${this.cssClasses.countdown}" data-expiry-seconds="${expirySeconds}"></span>.</div>
                    <div class="${this.cssClasses.cta}">
                        ${this.renderView('_button', {
                            tagName: 'a',
                            body: 'Sign up to keep your data',
                            href: '/_actions/guest/subscribe',
                            target: '_overlay',
                        })}
                    </div>
                </div>
            </div>
        `;
    }
};
